import React, { useState } from 'react';
import { LuTicket } from 'react-icons/lu';
import { MdOutlineRoomService } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { allTypeListCategory } from '../../../../consts/typeListConst';
import {
    canAccessStore,
    STORE_RESERVATION_REQUIRED_MESSAGE,
} from '../../../../helpers/storeAccess';
import useRem from '../../../../hooks/useRem';
import { useModalParkStore } from '../../../../store/park/modalParkStore';
import { useReservationStore } from '../../../../store/reservation/reservationStore';
import { useModalShoppingStore } from '../../../../store/shopping/modalShoppingStore';
import { Divider } from '../../../Divider';
import { CardShopContainer, LeftArea, RightArea } from './styles';

type CurrentType = 'tick' | 'service' | 'seeAll';

type Props = {
    close: () => void;
};

export const CardShopPopupHeader: React.FC<Props> = ({ close }) => {
    const [currentSelected, setCurrentSelected] = useState<CurrentType | null>(
        'tick'
    );
    const rem = useRem()
    const { setIsVisiblePark } = useModalParkStore();
    const { setIsVisibleShoppingWave } = useModalShoppingStore();
    const activeReservation = useReservationStore(state => state.activeReservation);
    const navigateTo = useNavigate();
    const handleChangeCurrent = (newValue: CurrentType) => {
        close();
        setCurrentSelected(newValue);
    };

    const handleOpenPark = () => setIsVisiblePark(true);
    const handleOpenStore = () => {
        if (!canAccessStore({ activeReservation })) {
            toast.warning(STORE_RESERVATION_REQUIRED_MESSAGE);
            return;
        }
        setIsVisibleShoppingWave(true);
    };
    const handleScrollServices = () => {
        navigateTo('/', { viewTransition: true });
        setTimeout(() => {
            const yOffset = -1 * 5 * rem;
            const element = document.getElementById('services-header');
            if (!element) return;
            const y =
                element.getBoundingClientRect().top + window.scrollY + yOffset;

            window.scrollTo({ top: y, behavior: 'smooth' });
        }, 50);
    };

    return (
        <CardShopContainer>
            <LeftArea>
                <button
                    aria-selected={currentSelected === 'tick'}
                    onClick={() => handleChangeCurrent('tick')}
                >
                    <LuTicket size={'1.5rem'} />
                    <p>Tickets</p>
                </button>
                {/* <button
                    aria-selected={currentSelected === 'service'}
                    onClick={() => handleChangeCurrent('service')}
                >
                    <MdOutlineRoomService size={'1.5rem'} />
                    <p>Serviços</p>
                </button> */}
                <button
                    aria-selected={currentSelected === allTypeListCategory.name}
                    onClick={handleScrollServices}
                >
                    <MdOutlineRoomService size={'1.5rem'} />
                    {/* <p>{allTypeListCategory.name}</p> */}
                    <p>Serviços</p>
                </button>
            </LeftArea>
            <Divider className="vertical-divider" />
            <RightArea>
                {currentSelected === 'tick' && (
                    <>
                        <button onClick={handleOpenStore}>Surfar</button>
                        <button onClick={handleOpenPark}>Parque</button>
                    </>
                )}
            </RightArea>
        </CardShopContainer>
    );
};
